import { Component } from '@angular/core';
import { ModalController, ToastController, Platform } from '@ionic/angular';
import { MembersPortalService } from '../../angular-wallet-base/services/members-portal.service';
import { TranslateService } from '@ngx-translate/core';
import { getToastPosition, isEnterKey, copyToClipboard } from '../../angular-wallet-base/utils';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { PREVENT_2FA_REAUTH_TIMEOUT } from '../../angular-wallet-base/constants';
import { AppState } from '../../angular-wallet-base/store/appState';
import { Store } from '@ngrx/store';
import { PreventAuthOnResumeAction } from '../../angular-wallet-base/actions/wallet.actions';

@Component({
  selector: 'enable-2fa-modal',
  templateUrl: './enable-2fa-modal.component.html',
  styleUrls: ['./enable-2fa-modal.component.scss'],
})

export class Enable2FAModalComponent {
  public step: number = 1;
  public google2fresponse;
  public password;
  public twofacode;
  public enabled2fa: boolean = false;
  public showPwd: boolean = false;
  constructor(private modal: ModalController,
              private portalService: MembersPortalService,
              private translate: TranslateService,
              private platform: Platform,
              private clipboard: Clipboard,
              private store: Store<AppState>,
              private toast: ToastController) {

  }

  async onNext() {  
    switch(this.step) {
      case 1:
        await this.generateCode();
        break;
      case 2:
        this.step += 1; 
        break;
      case 3:
        await this.submitCode(); 
        break;
      default:
        break;
    }

  }

  onBack() {
    this.step -= 1;
  }

  async generateCode() {
    try {
      this.google2fresponse = await this.portalService.generateGoogle2fa();
      this.store.dispatch(new PreventAuthOnResumeAction({preventLogout: true, preventAuthDuration: PREVENT_2FA_REAUTH_TIMEOUT}));
      this.step += 1;
    } catch(err) {
      this.presentToast('settings.toast_msgs.err_hdr','settings.toast_msgs.generate2fa_err_msg');
    }
  }

  async submitCode() {
    try {
      await this.portalService.enable2FA(this.password,this.twofacode.toString());
      this.enabled2fa = true;
      this.closeModal();
    }catch(err){
      this.presentToast('settings.toast_msgs.err_hdr','settings.toast_msgs.enable2fa_err_msg');
    }
  }

  async closeModal() {
    this.store.dispatch(new PreventAuthOnResumeAction({preventLogout: false}));
    await this.modal.dismiss({enabled: this.enabled2fa});
  }

  onKeyUp(ev) {
    if (isEnterKey(ev)) {
      this.onNext();
    }
  }

  toggleShowPwd() {
    this.showPwd = !this.showPwd;
  }

  async presentToast(hdr,msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000
    });
    await toast.present();
  }

  async copySecret() {
    if (this.platform.is('cordova')) {
      await this.clipboard.copy(this.google2fresponse.secret);
    } else {
      copyToClipboard(this.google2fresponse.secret);
    }
    this.presentToast('settings.toast_msgs.ok_hdr','settings.toast_msgs.copied_2facode_msg');
  }

}
